import { render, staticRenderFns } from "./CardRoomTime.vue?vue&type=template&id=e31bb368&scoped=true&"
import script from "./CardRoomTime.vue?vue&type=script&lang=ts&"
export * from "./CardRoomTime.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e31bb368",
  null
  
)

export default component.exports